"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _react = _interopRequireDefault(require("react"));

var _ellipsis = _interopRequireDefault(require("polished/lib/mixins/ellipsis"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Text = _interopRequireDefault(require("../../Text"));

var _useIsLoading = _interopRequireDefault(require("../LoadingProvider/useIsLoading"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var ComputerSkills = function ComputerSkills(props) {
  var _props$computerSkills = props.computerSkills,
      computerSkills = _props$computerSkills === void 0 ? [] : _props$computerSkills;

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  var isLoading = (0, _useIsLoading["default"])();

  if (!computerSkills.length || isLoading) {
    return null;
  }

  return (0, _core.jsx)("div", {
    css: /*#__PURE__*/(0, _css2["default"])({
      paddingLeft: spacing(4)
    }, ";label:ComputerSkills;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9Ta2lsbHMvQ29tcHV0ZXJTa2lsbHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNCUyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvUmVzcG9uc2l2ZUpvYkNhcmQvU2tpbGxzL0NvbXB1dGVyU2tpbGxzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGdW5jdGlvbkNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IGVsbGlwc2lzTWl4aW4gZnJvbSAncG9saXNoZWQvbGliL21peGlucy9lbGxpcHNpcyc7XG5cbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi8uLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IFRleHQgZnJvbSAnLi4vLi4vVGV4dCc7XG5pbXBvcnQgdXNlSXNMb2FkaW5nIGZyb20gJy4uL0xvYWRpbmdQcm92aWRlci91c2VJc0xvYWRpbmcnO1xuXG5leHBvcnQgaW50ZXJmYWNlIENvbXB1dGVyU2tpbGxzUHJvcHMge1xuICBjb21wdXRlclNraWxscz86IHsgdmFsdWU/OiBzdHJpbmcgfVtdO1xufVxuXG5jb25zdCBDb21wdXRlclNraWxsczogRnVuY3Rpb25Db21wb25lbnQ8Q29tcHV0ZXJTa2lsbHNQcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyBjb21wdXRlclNraWxscyA9IFtdIH0gPSBwcm9wcztcbiAgY29uc3QgeyBzcGFjaW5nIH0gPSB1c2VUaGVtZSgpO1xuXG4gIGNvbnN0IGlzTG9hZGluZyA9IHVzZUlzTG9hZGluZygpO1xuXG4gIGlmICghY29tcHV0ZXJTa2lsbHMubGVuZ3RoIHx8IGlzTG9hZGluZykge1xuICAgIHJldHVybiBudWxsO1xuICB9XG4gIHJldHVybiAoXG4gICAgPGRpdiBjc3M9e3sgcGFkZGluZ0xlZnQ6IHNwYWNpbmcoNCkgfX0+XG4gICAgICB7Y29tcHV0ZXJTa2lsbHMubWFwKChjb21wdXRlclNraWxsLCBpbmRleCkgPT4ge1xuICAgICAgICByZXR1cm4gKFxuICAgICAgICAgIDxUZXh0IGtleT17aW5kZXh9IGNzcz17ZWxsaXBzaXNNaXhpbignMTAwJScpfT5cbiAgICAgICAgICAgIHtjb21wdXRlclNraWxsPy52YWx1ZX1cbiAgICAgICAgICA8L1RleHQ+XG4gICAgICAgICk7XG4gICAgICB9KX1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENvbXB1dGVyU2tpbGxzO1xuIl19 */"))
  }, computerSkills.map(function (computerSkill, index) {
    return (0, _core.jsx)(_Text["default"], {
      key: index,
      css: (0, _ellipsis["default"])('100%')
    }, computerSkill === null || computerSkill === void 0 ? void 0 : computerSkill.value);
  }));
};

__signature__(ComputerSkills, "useTheme{{ spacing }}\nuseIsLoading{isLoading}", function () {
  return [_useTheme2["default"], _useIsLoading["default"]];
});

var _default = ComputerSkills;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ComputerSkills, "ComputerSkills", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Skills/ComputerSkills.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Skills/ComputerSkills.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();